var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 123,
    viewBox: "0 0 307 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.743 1.29238C76.8253 -4.41622 47.5199 9.14538 33.1543 34.8844L-31.5905 150.89C-45.956 176.628 -42.114 208.69 -22.0739 230.306L68.2461 327.73C88.2863 349.346 119.966 355.6 146.717 343.22L267.283 287.427C294.034 275.048 309.771 246.85 306.265 217.584L290.458 85.677C286.951 56.4099 264.997 32.7295 236.078 27.0209L105.743 1.29238Z",
    fill: "#4D9AA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlob);
export default __webpack_public_path__ + "static/media/homeBlob.c67bb83885e3da2c433373e810419d60.svg";
export { ForwardRef as ReactComponent };